import React, { useMemo } from "react";
import { Answers } from "../types/quiz";
import { quizSteps } from "../data/quizSteps";
import { profiles } from "../data/profiles";
import { computeScores, rankProfiles, signalsFor } from "../utils/scoring";
import { getPersonalization } from "../utils/personalization";
import { ResultProfile } from "./ResultProfile";
import { ScoreChart } from "./ScoreChart";
import { AnswersRecap } from "./AnswersRecap";
import { OfferSection } from "./OfferSection";
export function ResultScreen({
  answers,
  name
}: {
  answers: Answers;
  name: string;
}) {
  const result = useMemo(() => {
    const scores = computeScores(quizSteps, answers);
    const {
      primary,
      secondary
    } = rankProfiles(scores);
    return {
      scores,
      primaryKey: primary,
      secondaryKey: secondary,
      primary: profiles.find(p => p.key === primary) ?? profiles[0],
      secondary: secondary ? profiles.find(p => p.key === secondary) ?? null : null,
      signals: signalsFor(quizSteps, answers, primary),
      personalization: getPersonalization(answers)
    };
  }, [answers]);
  return <div className="mx-auto max-w-4xl px-4 py-10 sm:px-6 md:py-14" data-id="element-333" data-mp="kanyr7jgwm54">
      <ResultProfile name={name} primary={result.primary} secondary={result.secondary} signals={result.signals} notes={result.personalization.notes} data-id="element-334" data-mp="k9cvd8txpgej">
        <ScoreChart scores={result.scores} primary={result.primaryKey} secondary={result.secondaryKey} name={name} data-id="element-335" data-mp="af48b0noafnr" />
        <AnswersRecap answers={answers} name={name} data-id="element-336" data-mp="1kpt0y35754n" />
      </ResultProfile>
      <OfferSection goal={result.personalization.goal} name={name} data-id="element-337" data-mp="1imrbgsmnnk3" />
    </div>;
}